import axios from 'axios';
import regeneratorRuntime from "regenerator-runtime";

function urlBase64ToUint8Array(base64String) {
	const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
	const base64 = (base64String + padding)
		.replace(/\-/g, '+')
		.replace(/_/g, '/');

	const rawData = window.atob(base64);
	const outputArray = new Uint8Array(rawData.length);

	for (let i = 0; i < rawData.length; ++i) {
		outputArray[i] = rawData.charCodeAt(i);
	}
	return outputArray;
}

async function getSubscriptionInfo({
	publicVapidKey,
	workerPath,
	workerScope,
}) {
	try {
		if (!navigator?.serviceWorker) {
			return [new Error('Not supported'), null];
		}

		const register = await navigator.serviceWorker.register(workerPath, {
			scope: workerScope,
		});

		const pushSubscription = await register.pushManager.subscribe({
			userVisibleOnly: true,
			applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
		});

		return [null, pushSubscription];
	} catch (error) {
		console.log('error registering', error);
		return [new Error('Not allowed'), null];
	}
}

async function activateChromiumNotifications({
	subscriptionAuth,
	chatKey,
	publicVapidKey,
	workerPath,
	workerScope,
}) {
	try {
		const [error, subscription] = await getSubscriptionInfo({
			publicVapidKey,
			workerPath,
			workerScope,
		});

		if (!subscription) {
			console.log('received error', error);
			return;
		}

		const stringifiedSub = JSON.parse(JSON.stringify(subscription));

		if (subscriptionAuth === stringifiedSub?.keys?.auth) {
			return;
		}

		await subscribeToChromiumNotifications({ chatKey, subscription });
	} catch (e) {
		console.log('Error subbing', e);
	}
}

function activateSafariNotifications({ deviceId, chatKey }) {
	try {
		const WEBSITE_PUSH_ID = 'web.chat.gettransport.com';
		const { permission, deviceToken } =
			window.safari.pushNotification.permission(WEBSITE_PUSH_ID);

		if (permission === 'granted' && deviceToken !== deviceId) {
			subscribeToApnNotifications({ chatKey, deviceId: deviceToken });
		} else if (permission === 'default') {
			window.safari.pushNotification.requestPermission(
				'https://chat.gettransport.com/v2/api/apn',
				WEBSITE_PUSH_ID,
				{ chatKey },
				(permission, deviceToken) => {
					if (permission === 'granted' && deviceToken !== deviceId) {
						subscribeToApnNotifications({ chatKey, deviceId: deviceToken });
					}
				}
			);
		}
	} catch (error) {
		console.log(error);
	}
}

export function activateNotifications({
	subscriptionAuth,
	chatKey,
	publicVapidKey,
	workerPath,
	workerScope,
	deviceId,
}) {
	const isProduction = self.location.hostname === 'gettransport.com';
	const subdomain = isProduction ? '' : 'demo.';
	// если это демо – не вызывать `activateSafariNotifications`
	if (window.safari && isProduction) {
		activateSafariNotifications({ deviceId, chatKey });
	}
	if (!window.safari) {
		activateChromiumNotifications({
			subscriptionAuth,
			chatKey,
			publicVapidKey,
			workerPath,
			workerScope,
		});
	}
}

function subscribeToChromiumNotifications({ chatKey, subscription }) {
	const isProduction = self.location.hostname === 'gettransport.com';
	const subdomain = isProduction ? '' : 'demo.';
	return axios({
		// тут подставлять `demo` при необходимости
		url: `https://${subdomain}chat.gettransport.com/v2/api/chats/${chatKey}/subscribe`,
		method: 'POST',
		data: {
			subscription,
		},
	});
}

async function subscribeToApnNotifications({ chatKey, deviceId }) {
	try {
		await axios({
			url: `https://chat.gettransport.com/v2/api/chats/${chatKey}/update/deviceId`,
			method: 'POST',
			data: {
				deviceId,
			},
		});
	} catch (error) {
		console.log(error);
	}
}
